import { ChangeDetectorRef, Directive, Input, ViewRef, inject } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { App } from '@df/core/app';
import { ListingSort } from '@df/catalog-ui/listing/sort/listing-sort';

@Directive()
export class ListingSortComponentDef {
    /**
     * Access to app
     */
    readonly app = inject(App);

    constructor(private ref: ChangeDetectorRef) {}

    /**
     * Sort model binding
     */
    @Input({
        required: true
    })
    sort!: ListingSort;

    /**
     * Is open
     */
    protected _open: boolean = false;
    set open(value: boolean) {
        this.openSetter(value);
    }
    get open() {
        return this._open;
    }

    protected openSetter(value: boolean) {
        this._open = value;
        this.detectChanges();
    }

    detectChanges(): void {
        const cd = this.ref;
        if (cd && !(<ViewRef>cd).destroyed) {
            cd.detectChanges();
        }
    }
}
